import React from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { TrendingUp, Briefcase, BarChart3, Target } from 'lucide-react';

const Business = () => {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundImage: 'url(/cyberpunk-banner.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      padding: '2rem',
      color: '#fff',
      position: 'relative'
    }}>
      {/* Dark overlay for better readability */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(10, 10, 30, 0.7)',
        zIndex: 0
      }} />
      
      <div style={{ position: 'relative', zIndex: 1 }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{
            fontSize: '3rem',
            background: 'linear-gradient(135deg, #00ffff, #00ff88)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '1rem',
            fontWeight: 'bold'
          }}>
            Business Intelligence
          </h1>
          <p style={{ color: '#888', fontSize: '1.1rem', maxWidth: '800px', margin: '0 auto' }}>
            Strategic business analysis, market insights, and AI-powered decision-making tools
          </p>
        </div>

        {/* Quick Stats */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '1.5rem',
          marginBottom: '3rem'
        }}>
          <Card style={{
            padding: '1.5rem',
            background: 'rgba(10, 10, 30, 0.1)',
            backdropFilter: 'blur(10px)',
            border: '2px solid rgba(0, 255, 255, 0.5)',
            boxShadow: '0 8px 32px rgba(0, 255, 255, 0.2)'
          }}>
            <TrendingUp size={32} style={{ color: '#00ffff', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem', color: '#fff', fontWeight: 'bold', textShadow: '0 0 10px rgba(0,255,255,0.5)' }}>Market Analysis</h3>
            <p style={{ color: '#fff', fontWeight: '500' }}>Real-time market trends and competitive intelligence</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(10, 10, 30, 0.1)',
            backdropFilter: 'blur(10px)',
            border: '2px solid rgba(0, 255, 136, 0.5)',
            boxShadow: '0 8px 32px rgba(0, 255, 136, 0.2)'
          }}>
            <BarChart3 size={32} style={{ color: '#00ff88', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem', color: '#fff', fontWeight: 'bold', textShadow: '0 0 10px rgba(0,255,136,0.5)' }}>Performance Metrics</h3>
            <p style={{ color: '#fff', fontWeight: '500' }}>Track KPIs and business performance indicators</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(10, 10, 30, 0.1)',
            backdropFilter: 'blur(10px)',
            border: '2px solid rgba(186, 85, 211, 0.5)',
            boxShadow: '0 8px 32px rgba(186, 85, 211, 0.2)'
          }}>
            <Target size={32} style={{ color: '#ba55d3', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem', color: '#fff', fontWeight: 'bold', textShadow: '0 0 10px rgba(186,85,211,0.5)' }}>Strategic Planning</h3>
            <p style={{ color: '#fff', fontWeight: '500' }}>AI-assisted business strategy and goal setting</p>
          </Card>
        </div>

        {/* Main Content Area */}
        <Card style={{
          padding: '2rem',
          background: 'rgba(10, 10, 30, 0.1)',
          backdropFilter: 'blur(10px)',
          border: '2px solid rgba(0, 255, 255, 0.4)',
          marginBottom: '2rem'
        }}>
          <h2 style={{ fontSize: '1.5rem', color: '#00ffff', marginBottom: '1.5rem' }}>Business Tools & Widgets</h2>
          <div style={{ color: '#fff', lineHeight: '1.8' }}>
            <p style={{ fontWeight: '500' }}>Business intelligence widgets and tools will be available here:</p>
            <ul style={{ marginTop: '1rem', paddingLeft: '2rem' }}>
              <li>Market Research Dashboard</li>
              <li>Competitor Analysis Tool</li>
              <li>Business Model Canvas</li>
              <li>SWOT Analysis Generator</li>
              <li>Financial Projections Calculator</li>
            </ul>
          </div>
        </Card>

        {/* AI Advisor Section */}
        <Card style={{
          padding: '2rem',
          background: 'rgba(10, 10, 30, 0.1)',
          backdropFilter: 'blur(10px)',
          border: '2px solid #00ffff',
          boxShadow: '0 8px 32px rgba(0, 255, 255, 0.3)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <Briefcase size={32} style={{ color: '#00ffff' }} />
            <h2 style={{ fontSize: '1.5rem', color: '#00ffff' }}>Business AI Advisor</h2>
          </div>
          <p style={{ color: '#fff', marginBottom: '1.5rem', fontWeight: '500' }}>
            Get strategic business advice from our AI business consultants. Ask about market trends, 
            competitive analysis, business strategy, or any business-related question.
          </p>
          <Button style={{
            background: 'linear-gradient(135deg, #00ffff, #00ff88)',
            color: '#000',
            fontWeight: 'bold',
            padding: '1rem 2rem'
          }}>
            Chat with Business AI
          </Button>
        </Card>
      </div>
      </div>
    </div>
  );
};

export default Business;